/**
 * Links in the header are added with default base styles for desktop screens.
 */

import { chakra, Link } from "@chakra-ui/react";

const HeaderLink = chakra(Link, {
  baseStyle: {
    px: 4,
    py: 2,
    color: "hjsBlack",
    textAlign: "center",
    _hover: { border: "none", textDecor: "none" },
    // _active: {
    //   borderWidth: "6px",
    //   borderStyle: "solid",
    //   borderImageSlice: "0 0 100% 0",
    //   borderImageSource:
    //     "linear-gradient(to right,var(--chakra-colors-yellow-500), var(--chakra-colors-teal-600))",
    // },
  },
});

export default HeaderLink;
